<template>
  <footer :class="footerClass" style="width: 100%;">
    <div class="m-w nav-line nav-line-footer footer font20">
      <div class="footer-left">
        <img src="/static/img/logo.svg" style="margin-right: 13px;" />
        果小7智慧小超
      </div>
      <div>
        Copyright © 2017 杭州几禾科技有限公司版权所有 <a href="https://beian.miit.gov.cn/" target="_blank">浙ICP备2021033855号-1</a>
      </div>
    </div>
  </footer>
</template>

<script>
  export default {
    props:{
      absolute: {
        type: Boolean,
        default: false,
      }
    },
    data(){
      console.log(this.absolute);
      return {
        footerClass: {
          'bg-black': true,
          absolute : this.absolute,
          relative: !this.relative
        }
      }
    }
  }
</script>

<style scoped>
  .footer{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  footer.relative{
    position: relative;
  }

  footer.absolute{
    position: absolute;
    bottom: 0;
  }

  footer::before{
    position: absolute;
    content: '';
    width: calc(100% - 4.2vw);
    margin: 0 2.08vw;
    height: 1px;
    top: 0;
    background-color: rgba(255,255,255,.1);
  }

  .footer-left{
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .footer img{
    width: 43px;
    height: 43px;
  }

  .nav-line{
    color: #FFFFFF;
  }
  .nav-line a{
    color: #FFFFFF;
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue